import { Component, inject, Input, OnChanges, OnInit } from '@angular/core';
import { ProductListByIdsComponent, ProductService } from 'gung-standard';
import { CarLinerIncludedItemsByIdsService } from '../../services/car-liner-included-items-by-ids.service';

@Component({
    selector: 'car-liner-included-items-by-ids',
    templateUrl: './car-liner-included-items-by-ids.component.html',
    styleUrls: ['./car-liner-included-items-by-ids.component.scss'],
    providers: [CarLinerIncludedItemsByIdsService],
    standalone: false
})
export class CarLinerIncludedItemsByIdsComponent extends ProductListByIdsComponent implements OnInit {
  public carLinerIncludedItemsByIdsService = inject(CarLinerIncludedItemsByIdsService)

  @Input()
  private _parentId: string;

  @Input() set parentId(value: string) {
    this._parentId = value;
    this.carLinerIncludedItemsByIdsService.setParentId(this._parentId);
  }

  override ngOnInit() {
    this.configService = this.carLinerIncludedItemsByIdsService;
    super.ngOnInit();
  }
}
